import { ProfileActions } from "./ProfileActions";
import { ProfileBadges } from "./ProfileBadges";
import { ProfileBanner } from "./ProfileBanner";
import { ProfileBio } from "./ProfileBio";
import { ProfileCard } from "./ProfileCard";
import { ProfileJoined } from "./ProfileJoined";
import { ProfileMutuals } from "./ProfileMutuals";
import { ProfileOwner } from "./ProfileOwner";
import { ProfileRoles } from "./ProfileRoles";
import { ProfileStatus } from "./ProfileStatus";

export const Profile = {
  Actions: ProfileActions,
  Badges: ProfileBadges,
  Banner: ProfileBanner,
  Bio: ProfileBio,
  Card: ProfileCard,
  Joined: ProfileJoined,
  Mutuals: ProfileMutuals,
  Roles: ProfileRoles,
  Status: ProfileStatus,
  Owner: ProfileOwner,
};
